import type { AxiosInstance, AxiosRequestConfig } from 'axios'
import axios from 'axios'
import Swal from '@/includes/swal'
import qs from 'qs'
import type { CustomWindow } from '@/misc/custom-window'
import { showToast } from '@/general'

declare let window: CustomWindow

const http = axios.create({
  paramsSerializer: {
    serialize: (params: Record<string, unknown>): string => {
      return qs.stringify(params, { arrayFormat: 'brackets' })
    }
  }
} as AxiosRequestConfig) as AxiosInstance

http.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'
http.defaults.withCredentials = true

http.interceptors.request.use((config) => {
  (config as CustomAxiosRequestConfig).errorContext = new Error('Thrown at:')

  if (window.Echo && window.Echo?.socketId()) {
    config.headers['X-Socket-ID'] = window.Echo.socketId()
  }

  return config
})

http.interceptors.response.use(
  undefined,
  async (e) => {
    const status = e?.response?.status

    if (status && [401, 419].includes(status)) {
      return redirectToLogin().then(() => window.location.href = '/login')
    }

    // @ts-ignore
    const originalStackTrace = (e?.config as CustomAxiosRequestConfig)?.errorContext?.stack

    if (originalStackTrace) {
      e.stack = `${e?.stack}\n${originalStackTrace}`
    }

    // @ts-ignore
    if (status && ![0, 300, 401, 403, 404, 405, 409, 413, 419, 420, 422].includes(status) && ['production', 'develop', 'staging'].includes(window.APP_ENV)) {
      const Sentry = await import('@/includes/sentry')

      Sentry.default.captureException(e)
    }

    if (status === 403 && window.APP_ENV === 'local') {
      await showToast('Je hebt geen rechten om deze actie uit te voeren', 'warning')
    }

    throw e
  })

const redirectToLogin = async () => {
  return await Swal.fire({
    title: ' ',
    text: 'U dient opnieuw in te loggen, de huidige sessie is verlopen!',
    icon: 'error',
    showCancelButton: false,
    confirmButtonColor: '#F08825',
    confirmButtonText: 'Inloggen',
  })
}

export default http
